import {SwitchArrowIcon} from '../../../icons'
import './index.scss'
import {useEffect, useRef, useState} from 'react'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'
import {useLocation} from 'react-router-dom'
import {useSelector} from 'react-redux'
import classNames from 'classnames'

const DataSwitcher = ({children}) => {
    const location = useLocation()
    const ref = useRef()
    const [isActive, setIsActive] = useState(false)
    useOutsideClick(ref, () => setIsActive(false))

    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    useEffect(() => {
        setIsActive(false)
    }, [location])
    return (
        <div className="data-switcher" ref={ref}>
            <span className="switch-icon" onClick={() => setIsActive(true)}>
                <SwitchArrowIcon/>
            </span>
            {isActive ? (
                <div className={classNames('popover', {
                    dark: isDarkMode
                })}>
                    {children}
                </div>
            ) : null}
        </div>
    )
}

export default DataSwitcher
